export default __webpack_public_path__ + "static/media/extra_out_l8.28be609b.svg";